export * from './user-profile.reducer';

import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromRouter from '@ngrx/router-store';
import * as fromUserProfile from './user-profile.reducer';
import * as fromFittings from './fittings.reducer';
import * as fromClosures from './closures.reducer';
import * as fromPigs from './pig.reducer';
import * as fromSearch from './search.reducer';
import * as fromErrors from './errors.reducer';
import * as fromAdmin from './admin';
import * as fromMetaReducers from './meta';
import * as fromMessages from './messages.reducer';
import * as fromORings from './oring.reducer';
import * as fromGuide from './pig-product-guide.reducer';
import * as fromPE from './pe.reducer';
import * as fromPigSig from './pigsig.reducer';
import * as fromSealingElements from './sealing-element.reducer';
import * as fromSealingElementsMaintenance from './sealing-element-maintenance.reducer';
import * as fromEquipment from './equipment.reducer';
import { storeFreeze } from 'ngrx-store-freeze';

const META = [fromMetaReducers.clearStateOnLogout];

export interface State {
  userProfile: fromUserProfile.State,
  router: fromRouter.RouterReducerState<any>;
  fittings: fromFittings.State,
  closures: fromClosures.State,
  pig: fromPigs.State,
  search: fromSearch.State,
  errors: fromErrors.State,
  admin: fromAdmin.State,
  messages: fromMessages.State,
  orings: fromORings.State,
  pigProductGuide: fromGuide.State,
  pe: fromPE.State,
  pigSig: fromPigSig.State,
  sealingElements: fromSealingElements.State,
  sealingElementMaintenance: fromSealingElementsMaintenance.State,
  equipment: fromEquipment.State
}

export const reducers: ActionReducerMap<State> = {
  userProfile: fromUserProfile.reducer,
  router: fromRouter.routerReducer,
  fittings: fromFittings.reducer,
  closures: fromClosures.reducer,
  pig: fromPigs.reducer,
  search: fromSearch.reducer,
  errors: fromErrors.reducer,
  admin: fromAdmin.reducers,
  messages: fromMessages.reducer,
  orings: fromORings.reducer,
  pigProductGuide: fromGuide.reducer,
  pe: fromPE.reducer,
  pigSig: fromPigSig.reducer,
  sealingElements: fromSealingElements.reducer,
  sealingElementMaintenance: fromSealingElementsMaintenance.reducer,
  equipment: fromEquipment.reducer
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [storeFreeze, ...META] : [...META];


export const LOADERS = {
  USERPROFILE: fromUserProfile.Loaders,
  FITTINGS: fromFittings.Loaders,
  CLOSURES: fromClosures.Loaders,
  PIGS: fromPigs.Loaders,
  SEARCH: fromSearch.Loaders,
  ADMIN: fromAdmin.Loaders,
  GUIDE: fromGuide.Loaders,
  PE: fromPE.Loaders,
  PigSig: fromPigSig.Loaders,
  sealingElements: fromSealingElements.Loaders,
  orings: fromORings.Loaders,
}
